import React from 'react'

const HomeActive = props => (
  <svg width={24} height={24} {...props}>
    <path
      d="M13.667 18.45c0 .47-.373.85-.834.85h-1.666a.842.842 0 01-.834-.85V15.9c0-.938.747-1.7 1.667-1.7s1.667.762 1.667 1.7v2.55zm7.981-7.477l.009-.014-9.167-6.802-.107-.055-.09-.047a.814.814 0 00-.587 0l-.088.046-.108.056-9.167 6.802.009.014a.842.842 0 00.481 1.525.8.8 0 00.482-.176l.008.013.344-.255v8.07c0 .468.375.85.833.85h15a.844.844 0 00.833-.85v-8.07l.344.255.008-.013a.8.8 0 00.482.176.842.842 0 00.481-1.525z"
      fillRule="evenodd"
      fill={props.fill}
    />
  </svg>
)

export default HomeActive
